import { config } from './tailwind/src/config';
export default config;
